// The boot loads the account settings alongside /auth/me, for the account kept in localStorage. Right after a
// sign-in, an account switch or a sign-in handed over from the other app, that account may not be the token's
// yet, so the page that does one of them marks it and the next boot waits for /auth/me. Per tab: sessionStorage
// survives the reload but not another tab.
const SESSION_CHANGED_KEY = 'sc-session-changed';

export const markSessionChanged = (): void => {
  try {
    sessionStorage.setItem(SESSION_CHANGED_KEY, 'true');
  } catch {
    // storage blocked: the next boot still waits, see takeSessionChanged
  }
};

// Read once per boot: the mark is removed so the following reloads load in parallel again
export const takeSessionChanged = (): boolean => {
  try {
    const isChanged = sessionStorage.getItem(SESSION_CHANGED_KEY) !== null;
    sessionStorage.removeItem(SESSION_CHANGED_KEY);

    return isChanged;
  } catch {
    // unreadable: waiting is the safe choice
    return true;
  }
};
